// extracted by mini-css-extract-plugin
export default {"eight":"screen_eight__7QzMD","bg":"screen_bg__Z1YX4"};